import NextHead from 'next/head';

import PropTypes from 'prop-types';

function getFullUrlPerPageType(isKit, key) {
  if (key) {
    const pageType = isKit ? 'kit' : 'product';
    const url = `/shop/${pageType}/${key}`;
    return new URL(url, `https://www.zola.com`).toString();
  }
  return null;
}

const Header = ({
  productBrand,
  productCanonicalKey,
  productTitle,
  productDescription,
  productImage,
  productKey,
  isKit,
  // eslint-disable-next-line no-unused-vars
  partnerRetailerKey = '',
}) => {
  const title = productBrand ? `${productBrand}, ${productTitle}` : `${productTitle}`;
  const defaultMetaDescription =
    'Give your space a major upgrade with home essentials from all your favorite brands. Add these great gifts to your Zola Wedding Registry.';

  // regex used to strip the html tags that are included in the description from the API
  const metaDescription =
    (productDescription && productDescription.replace(/(<.*?>)/g, '')) || defaultMetaDescription;

  // Construct meta link
  const metaLink = getFullUrlPerPageType(isKit, productKey);
  const canonicalUrl = getFullUrlPerPageType(isKit, productCanonicalKey);

  /*
   * De-index Registry PDPs to let
   * homestore PDPs shine
   * Except for our parternships (i.e. Macy's and Crate and Barrel)
   */
  // const brandsToIndex = ['crate-barrel', 'macys'];

  // NOTE: temporarily fix to check whether the product image url has the https protocol and if not then to append it
  const metaImageUrl = productImage[0] === 'h' ? productImage : `https:${productImage}`;
  const defaultTitle = `${title} - Zola`;
  return (
    <NextHead>
      <title key="title">{defaultTitle}</title>
      {/* {!brandsToIndex.includes(partnerRetailerKey) && <meta name="robots" content="noindex" />} */}
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={canonicalUrl || metaLink} />
      <meta name="twitter:site" content="@zola" />
      <meta name="twitter:card" content="summary" />
      <meta property="og:type" content="product" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImageUrl} />
      <meta property="og:site_name" content="Zola" />
      <meta property="og:url" content={metaLink} />
    </NextHead>
  );
};

Header.defaultProps = {
  isKit: false,
};

Header.propTypes = {
  productTitle: PropTypes.string,
  productBrand: PropTypes.string,
  productDescription: PropTypes.string,
  productImage: PropTypes.string,
  productKey: PropTypes.string,
  isKit: PropTypes.bool,
  partnerRetailerKey: PropTypes.string,
};

export default Header;
